module.exports = __webpack_public_path__ + "img/img_video.7ea1f775.svg";